import { createAction, createAsyncAction } from 'typesafe-actions';
import { FhqGeneralSetting, FhqGeneralSettingDto } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';

export const fetchFhqGeneralSettings = createAsyncAction(
  'FETCH_FHQ_GENERAL_SETTINGS_REQUEST',
  'FETCH_FHQ_GENERAL_SETTINGS_SUCCESS',
  'FETCH_FHQ_GENERAL_SETTINGS_FAILURE',
)<IdType, FhqGeneralSetting, Error>();

export const updateFhqGeneralSettings = createAsyncAction(
  'UPDATE_FHQ_GENERAL_SETTING_REQUEST',
  'UPDATE_FHQ_GENERAL_SETTING_SUCCESS',
  'UPDATE_FHQ_GENERAL_SETTING_FAILURE',
)<{ id: IdType; data: FhqGeneralSettingDto }, FhqGeneralSetting, Error>();

export const setGeneralSettingsIsLoading = createAction('SET_GENERAL_SETTINGS_IS_LOADING')<undefined>();
